import tw from 'twin.macro';
import 'styled-components/macro';

export interface FavoritesPageIconProps {
  itemsCount: number;
}

export const FavoritesPageIcon = ({ itemsCount }: FavoritesPageIconProps) => {
  return (
    <div
      tw="rounded ring-1 ring-gray-15 bg-primary py-1 px-2"
      css={[[itemsCount > 0 ? tw`bg-primary text-white` : tw`bg-white text-gray-30`]]}
      title="Favorites list"
    >
      <span css={[itemsCount && tw`mr-1`]}>{itemsCount ? '⭐' : '☆'}</span>
      {itemsCount ? itemsCount : ''}
    </div>
  );
};
